var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowUpQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.44,
    d: "M9.612 18.338a8.609 8.609 0 0 0 6.644-3.09c2.613-3.099 2.695-7.748.186-10.931a8.628 8.628 0 0 0-12.91-.78C.89 6.187.32 10.111 1.8 13.321c.123.309.6 1.155.92 1.713a.933.933 0 0 1-.046 1.005c-.211.298-.478.679-.686.992a.839.839 0 0 0 .693 1.307h.52c2.28 0 5.617-.002 6.411 0ZM9.5 12.993V13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.44,
    d: "M9.419 11.216c-.01-.787.704-1.122 1.236-1.426.647-.358 1.087-.929 1.087-1.72a2.109 2.109 0 0 0-2.108-2.114A2.103 2.103 0 0 0 7.528 8.07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpQuestion);
export default __webpack_public_path__ + "static/media/follow-up-question.bbb297fa87cb8bb98b9cb1386b12813d.svg";
export { ForwardRef as ReactComponent };